<template>
  <v-container>
    <v-card>
      <v-card-title>F5 Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="6"
            v-if="assyst_f5_nic != null"
          >
            <v-card
              elevation="2"
            >
              <v-card-title>
                <v-sheet
                  color="accent"
                  width="100%"
                  class="overflow-hidden mt-n6 transition-swing"
                  elevation="3"
                  max-width="100%"
                  rounded
                >
                  <v-theme-provider
                    dark
                  >
                    <div>
                      <v-icon
                        class="pa-2"
                      >
                        mdi-expansion-card
                      </v-icon>
                      <span
                        class="text-h6 white--text"
                      >
                        Assyst
                      </span>
                    </div>
                  </v-theme-provider>
                </v-sheet>
              </v-card-title>
              <v-card-text>
                <v-simple-table dense>
                  <tbody>
                    <tr>
                      <td>F5 NIC Name</td>
                      <td class="text-right">
                        {{ assyst_f5_nic.f5_nic_name }}
                      </td>
                    </tr>
                    <tr>
                      <td>F5 Local IP</td>
                      <td class="text-right">
                        {{ assyst_f5_nic.private_ip_address }}
                      </td>
                    </tr>
                    <tr>
                      <td>F5 Public IP</td>
                      <td class="text-right">
                        {{ assyst_f5_nic.public_ip_address }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            v-if="itom_f5_nic != null"
          >
            <v-card>
              <v-card-title>
                <v-sheet
                  color="accent"
                  width="100%"
                  class="overflow-hidden mt-n6 transition-swing"
                  elevation="3"
                  max-width="100%"
                  rounded
                >
                  <v-theme-provider
                    dark
                  >
                    <div>
                      <v-icon
                        class="pa-2"
                      >
                        mdi-expansion-card
                      </v-icon>
                      <span
                        class="text-h6 white--text"
                      >
                        ITOM
                      </span>
                    </div>
                  </v-theme-provider>
                </v-sheet>
              </v-card-title>
              <v-card-text>
                <v-simple-table dense>
                  <tbody>
                    <tr>
                      <td>F5 NIC Name</td>
                      <td class="text-right">
                        {{ itom_f5_nic.f5_nic_name }}
                      </td>
                    </tr>
                    <tr>
                      <td>Local IP</td>
                      <td class="text-right">
                        {{ itom_f5_nic.private_ip_address }}
                      </td>
                    </tr>
                    <tr>
                      <td>Public IP</td>
                      <td class="text-right">
                        {{ itom_f5_nic.public_ip_address }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        
        
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'F5Details',
    props: {
      assyst_f5_nic: Object,
      itom_f5_nic: Object,
    },
    data () {
      return {

      }
    },
  }
</script>
